import React from "react";
import ExtraBenefits from "./ExtraBenefitSelection.jsx";
import AppCard from "../../../../../../components/ui/AppCard";
import applyPolicyImage from "../../../../../../assets/images/patterns/applyPolicy.png";


const SelectProductBenefitForm = ({ moveToNextView, moveToPreviousView, userPolicyInput, setuserPolicyInput }) => {
  const handleMoveNext = () => {
    moveToNextView();
  };

  return (
    <div className="w-full max-w-5xl mx-auto px-4 mb-12">
      {userPolicyInput.selectedSubGroupPlan && (
        <AppCard headerImg={applyPolicyImage}>
          <div className="card-body p-8 md:p-10">
            <h4 className="text-xl font-bold text-base-content mb-6 pb-4 border-b border-base-200/50">
              Select your preferred product tier
            </h4>

            <div className="mb-10 min-h-[15rem]">
              <ExtraBenefits
                  moveToNextView={moveToNextView}
                  setuserPolicyInput={setuserPolicyInput}
                  userPolicyInput={userPolicyInput}
              />
            </div>

            <div className="card-actions justify-end mt-4 pt-6 border-t border-base-200/50">
              <button
                  onClick={handleMoveNext}
                  className="btn btn-primary rounded-full px-12 shadow-md hover:shadow-lg transition-all font-bold tracking-wide text-white"
              >
                Continue <i className="pi pi-arrow-right ml-2 text-sm"></i>
              </button>
            </div>
          </div>
        </AppCard>
      )}
    </div>
  );
};

export default SelectProductBenefitForm;
